export const refs = {
  categoriesList: document.querySelector('ul.categories'),
  productList: document.querySelector('ul.products'),
  loadMoreBtn: document.querySelector('.load-more-btn'),
  modal: document.querySelector('.modal'),
  modalBackdrop: document.querySelector('.js-modal-backdrop'),
  modalProduct: document.querySelector('.modal-product'),
  modalClose: document.querySelector('.modal__close-btn'),
  formSearch: document.querySelector('.search-form'),
  notFoundDiv: document.querySelector('.not-found'),
  clearBtn: document.querySelector('.search-form__btn-clear'),
  cartBtn: document.querySelector('.modal-product__btn--cart'),
  wishBtn: document.querySelector('.modal-product__btn--wishlist'),
  cartCount: document.querySelector('[data-cart-count]'),
  wishCount: document.querySelector('[data-wishlist-count]'),
};
